import React from 'react'

import Modal from 'components/Modal'
import { ModalInjectedProps } from 'containers/ModalManager'
import Button from 'components/Button'
import {
  TabList,
  Tab,
  Tabs,
  TabPanel,
  Breadcrumbs,
  BreadcrumbItem,
} from './ShareSettingsModal.styles'
import SharingAndPermissions from './SharingAndPermissions'
import DocumentInfo from './DocumentInfo'

import ProjectName from 'components/ProjectName'
import { ShareForSettingsModal, VersionForSettingsModal } from './types'

interface ShareSettingsModalProps extends ModalInjectedProps {
  share: ShareForSettingsModal
  version: VersionForSettingsModal
  openPermissions?: boolean
}

const getBreadcrumbs = (share: ShareForSettingsModal): React.ReactNode[] => {
  const { workspace } = share
  const project = share.project

  const breadcrumbs: React.ReactNode[] = []

  breadcrumbs.push(
    <BreadcrumbItem
      key={workspace.name}
      data-testid="share-settings-owner-name">
      {workspace.name}
    </BreadcrumbItem>
  )

  /* Project crumb */
  if (project?.name) {
    breadcrumbs.push(
      <BreadcrumbItem key={project.shortId}>
        <ProjectName project={project} />
      </BreadcrumbItem>
    )
  }

  /* Share crumb */
  if (share.name) {
    breadcrumbs.push(
      <BreadcrumbItem key={share.identifier}>{share.name}</BreadcrumbItem>
    )
  }

  return breadcrumbs
}

const ShareSettingsModal = ({
  hideModal,
  share,
  version,
  openPermissions = false,
}: ShareSettingsModalProps): JSX.Element => {
  const breadcrumbs = getBreadcrumbs(share)

  return (
    <Modal onCancel={hideModal}>
      <Modal.Header>Document Settings</Modal.Header>
      <Modal.Body>
        <Breadcrumbs>{breadcrumbs}</Breadcrumbs>
        <Tabs selectedTabIndex={openPermissions ? 1 : 0}>
          <TabList>
            <Tab>General</Tab>
            <Tab>Sharing</Tab>
          </TabList>
          <TabPanel>
            <DocumentInfo share={share} version={version} />
          </TabPanel>
          <TabPanel>
            <SharingAndPermissions share={share} />
          </TabPanel>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={hideModal}>Done</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default ShareSettingsModal
